import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import LabelFilterForm from "../components/ReportPages/AddressLabel/LabelFilterForm";
import NpfUafFilterForm from "../components/ReportPages/NpfUafLabel/NpfUafFilterForm";
import DonationRepotFilter from "../components/ReportPages/DonationReport/DonationFilter";
import BookwiseReportFilterForm from "../components/ReportPages/BookWiseReport/BookWiseReportFilterForm";
import PanCardFilters from "../components/ReportPages/PanCardReport/PanCardFilters";
import SummaryFilter from "../components/ReportPages/summary/SummaryFilter";
import YearlySummaryFilter from "../components/ReportPages/YearwiseSummary/YearwiseSummaryFilter";
import FinancialYearFilter from "../components/ReportPages/StartEndBookNo/FinancialYearFilter";
import { usePageLogger } from "../hooks/usePageLogger";
import { logger } from "../utils/logger";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: { xs: 1, sm: 2 } }}>{children}</Box>}
  </div>
);

const Report = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { user } = useSelector((state) => state.auth);
  usePageLogger("Report Page", { username: user?.username, role: user?.role });
  const tabLabels = [
    "Address Label",
    "NPF UPF Label",
    "Donation Report",
    "Pan Details",
    "Break up of Paymode",
    "Summary",
    "Yearwise Summary",
    "Book-Analysis year-wise",
  ];
  const ROLE_ACCESS = {
    "Address Label": ["superadmin", "admin1", "admin2"],
    "NPF UPF Label": ["superadmin", "admin1", "admin2"],
    "Donation Report": ["superadmin", "admin1", "admin2"],
    "Pan Details": ["superadmin", "admin1", "admin2"],
    "Break up of Paymode": ["superadmin", "admin1", "admin2"],
    Summary: ["superadmin", "admin1", "admin2"],
    "Yearwise Summary": ["superadmin", "admin1", "admin2"],
    "Book-Analysis year-wise": ["superadmin", "admin1", "admin2"],
  };
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    logger.info(`Report tab opened: ${tabLabels[newValue]}`, {
      page: `Reports > ${tabLabels[newValue]}`,
      username: user?.username,
      role: user?.role,
    });
  };

  useEffect(() => {
    logger.info(`Report tab opened: ${tabLabels[0]}`, {
      page: `Reports > ${tabLabels[0]}`,
      username: user?.username,
      role: user?.role,
    });
  }, []);

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 3 },
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Typography variant={isMobile ? "h5" : "h4"} gutterBottom>
        Report
      </Typography>

      <Card
        sx={{
          width: "100%",
          boxShadow: 3,
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons="auto"
          aria-label="report tabs"
        >
          {tabLabels.map((label, idx) => {
            // check access
            const canAccess = ROLE_ACCESS[label]?.includes(user?.role);
            return canAccess ? <Tab key={idx} label={label} /> : null;
          })}
        </Tabs>

        <CardContent>
          <TabPanel value={tabIndex} index={0}>
            <LabelFilterForm />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <NpfUafFilterForm />
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>
            <DonationRepotFilter />
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
            <PanCardFilters />
          </TabPanel>
          <TabPanel value={tabIndex} index={4}>
            <BookwiseReportFilterForm />
          </TabPanel>
          <TabPanel value={tabIndex} index={5}>
            <SummaryFilter />
          </TabPanel>
          <TabPanel value={tabIndex} index={6}>
            <YearlySummaryFilter />
          </TabPanel>
          <TabPanel value={tabIndex} index={7}>
            <FinancialYearFilter />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Report;
